import DocumentDetails from "../GridDataComponent/DocumentDetails";
import "../../CriminalCertificateValidation.css";

const  CriminalCertificate = () =>{
  return(
   <DocumentDetails documentType={'myai/criminal-documents'} keyAccess={'IDCriminalDocument'} title={'Criminal Certificate'} exportDataToExcelName={'CriminalCertificate Document'} analysefrom={'criminal-document'} deleteText={'myai/criminal-document'} modelName={'my-ai'} webSocketName = {'criminaldocument'}/>
  )
 };
 export default CriminalCertificate;